import { Component, Inject, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { Boat } from '@shared/models/boat';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'choose-boat-dialog',
    templateUrl: './choose-boat-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChooseBoatDialogComponent implements OnInit {
    dataSource: Boat[];

    displayedColumns = ['name', 'licensePlate', 'type', 'length', 'width'];

    constructor(
        public dialogRef: MatDialogRef<ChooseBoatDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: {
            boats?: Boat[],
        },
    ) {
    }

    ngOnInit(): void {
        this.dataSource = this.data.boats;
    }

    selectBoat(boat: Boat): void {
        this.dialogRef.close(boat);
    }

}
